export default "__VITE_PUBLIC_ASSET__52f268a0__"